"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _wechatOpenPlatformApi = require("@/api/wechatOpenPlatformApi");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var emptyForm = function emptyForm() {
  return {
    id: null,
    platformName: '',
    componentAppId: '',
    componentSecret: '',
    messageToken: '',
    encodingAesKey: '',
    publicBaseUrl: '',
    enabled: 1
  };
};
var _default = exports.default = {
  data: function data() {
    return {
      loading: false,
      saving: false,
      startingId: null,
      list: [],
      formVisible: false,
      urlVisible: false,
      form: emptyForm(),
      selected: {},
      rules: {
        platformName: [{
          required: true,
          message: '请输入配置名称',
          trigger: 'blur'
        }],
        componentAppId: [{
          required: true,
          message: '请输入第三方平台AppID',
          trigger: 'blur'
        }],
        componentSecret: [{
          required: true,
          message: '请输入ComponentSecret',
          trigger: 'blur'
        }],
        messageToken: [{
          required: true,
          message: '请输入消息校验Token',
          trigger: 'blur'
        }],
        encodingAesKey: [{
          required: true,
          message: '请输入EncodingAESKey',
          trigger: 'blur'
        }],
        publicBaseUrl: [{
          required: true,
          message: '请输入公网HTTPS地址',
          trigger: 'blur'
        }]
      }
    };
  },
  created: function created() {
    this.load();
  },
  methods: {
    load: function () {
      var _load = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.loading = true;
              _context.p = 1;
              _context.n = 2;
              return (0, _wechatOpenPlatformApi.getPlatformList)();
            case 2:
              _t = _context.v;
              if (_t) {
                _context.n = 3;
                break;
              }
              _t = [];
            case 3:
              this.list = _t;
            case 4:
              _context.p = 4;
              this.loading = false;
              return _context.f(4);
            case 5:
              return _context.a(2);
          }
        }, _callee, this, [[1,, 4, 5]]);
      }));
      function load() {
        return _load.apply(this, arguments);
      }
      return load;
    }(),
    openCreate: function openCreate() {
      this.form = emptyForm();
      this.formVisible = true;
    },
    openEdit: function openEdit(row) {
      this.form = _objectSpread(_objectSpread({}, emptyForm()), {}, {
        id: row.id,
        platformName: row.platformName,
        componentAppId: row.componentAppId,
        publicBaseUrl: row.publicBaseUrl,
        enabled: row.enabled
      });
      this.formVisible = true;
    },
    submit: function submit() {
      var _this = this;
      this.$refs.form.validate(/*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(valid) {
          var result;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.p = _context2.n) {
              case 0:
                if (valid) {
                  _context2.n = 1;
                  break;
                }
                return _context2.a(2);
              case 1:
                _this.saving = true;
                _context2.p = 2;
                _context2.n = 3;
                return (0, _wechatOpenPlatformApi.savePlatform)(_this.form);
              case 3:
                result = _context2.v;
                if (result && result.enabled === 0) {
                  _this.$message.success('保存成功');
                } else if (result && result.ticketPushStarted) {
                  _this.$message.success('保存成功，已请求微信启动Ticket推送');
                } else {
                  _this.$message.warning(result && result.lastError || '配置已保存，但启动Ticket推送失败');
                }
                _this.formVisible = false;
                _context2.n = 4;
                return _this.load();
              case 4:
                _context2.p = 4;
                _this.saving = false;
                return _context2.f(4);
              case 5:
                return _context2.a(2);
            }
          }, _callee2, null, [[2,, 4, 5]]);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    startPush: function () {
      var _startPush = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(row) {
        var result;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              this.startingId = row.id;
              _context3.p = 1;
              _context3.n = 2;
              return (0, _wechatOpenPlatformApi.startTicketPush)(row.id);
            case 2:
              result = _context3.v;
              if (result && result.ticketPushStarted) {
                this.$message.success('已请求微信启动Ticket推送，请稍后刷新状态');
              } else {
                this.$message.warning(result && result.lastError || '启动Ticket推送失败');
              }
              _context3.n = 3;
              return this.load();
            case 3:
              _context3.p = 3;
              this.startingId = null;
              return _context3.f(3);
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this, [[1,, 3, 4]]);
      }));
      function startPush(_x2) {
        return _startPush.apply(this, arguments);
      }
      return startPush;
    }(),
    showUrls: function showUrls(row) {
      this.selected = row;
      this.urlVisible = true;
    },
    copy: function copy(value) {
      var input = document.createElement('textarea');
      input.value = value || '';
      document.body.appendChild(input);
      input.select();
      document.execCommand('copy');
      document.body.removeChild(input);
      this.$message.success('已复制');
    }
  }
};